const CheckFormSettingField = (formSettingList = [], settingName) => {
  if (!formSettingList || formSettingList.length === 0) {
    return true;
  }

  const searchSetting = settingName ? settingName.toLowerCase() : "";
  try {
    const isFound = formSettingList.some(
      listItem =>
        listItem.parameter &&
        listItem.parameter.trim().toLowerCase() == searchSetting &&
        listItem.parameter_value
    );
    return isFound;
  } catch (error) {
    return true;
  }
};

export default CheckFormSettingField;